import CommonResources from "../login-registration/CommonResources";

export const ForgetPasswordFormResources = {
    backToLogin: "Wstecz do logowania",
    modalHeaderText: "Zapomniałeś hasła?",
    message: "Podaj swój e-mail, na który wyślemy Ci link pozwalający ustalić nowe hasło.",
    sentMessageOne: "E-mail został wysłany na adres: ",
    sentMessageTwo: "Sprawdź swoją pocztę i użyj linku, aby nadać nowe hasło.",
    recoveryButton: "Wyślij",
    emailWatermark: CommonResources.email,
    emailRequiredError: "E-mail jest wymagany",
    emailInvalidError: "Wprowadź poprawny adres e-mail",
};
